import ApiBase from "./ApiBase";

export default class SocialMedia {

	static getRooms(successCallback, errorCallback, alwaysCallback) {
		return ApiBase.getData("/api/socialmedia/getrooms", null, successCallback, errorCallback, alwaysCallback);
	}
	static getConfigurations(query, successCallback, errorCallback, alwaysCallback) {
		return ApiBase.postData("/api/socialmedia/getconfigurations", query, successCallback, errorCallback, alwaysCallback);
	}
	static getRoom(query, successCallback, errorCallback, alwaysCallback) {
		return ApiBase.getData("/api/socialmedia/getRoom?roomid=" + query, null, successCallback, errorCallback, alwaysCallback);
	}
	static getPosts(query, successCallback, errorCallback, alwaysCallback) {
		return ApiBase.postData("/api/socialmedia/getposts", query, successCallback, errorCallback, alwaysCallback);
	}
	static saveFilters(query, successCallback, errorCallback, alwaysCallback) {
		return ApiBase.putData("/api/socialmedia/savefilters", query, successCallback, errorCallback, alwaysCallback);
	}
}
